/**
 * Gift email-only con soglia minima d'ordine
 * -------------------------------------------
 * Aggiunge/rimuove automaticamente un prodotto regalo (es. Travel Bag)
 * quando il totale del carrello supera una soglia, MA solo se il cliente
 * è arrivato tramite un link con un parametro URL specifico (es. da un'email).
 *
 * Si aggancia al sistema pub/sub già presente nel tema (constants.js / pubsub.js),
 * lo stesso usato da cart.js per aggiornare il carrello dopo ogni modifica.
 *
 * CONFIGURAZIONE: modifica i valori qui sotto prima di caricare lo script.
 */

(function () {
  const CONFIG = {
    // ID della VARIANTE del prodotto Travel Bag (non l'ID prodotto).
    giftVariantId: 53266518573399,

    // Soglia minima in valuta (es. 50 = $50 / €50)
    thresholdAmount: 50,

    // Nome del parametro URL usato nel link dell'email, es:
    // https://tuosito.com/?promo=travelbag50
    urlParamName: "promo",
    urlParamValue: "travelbag50",

    // Property univoca usata per riconoscere la riga "regalo" nel carrello
    // (stessa convenzione già usata nel tema per i samples: _is_sample)
    giftPropertyKey: "_is_gift_travelbag",

    // Chiave usata in sessionStorage per ricordare l'eleggibilità durante la sessione
    storageKey: "email_gift_eligible",
  };

  function isEligibleFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get(CONFIG.urlParamName) === CONFIG.urlParamValue;
  }

  function markEligible() {
    try {
      sessionStorage.setItem(CONFIG.storageKey, "1");
    } catch (e) {
      /* storage non disponibile, ignora */
    }
  }

  function isEligible() {
    try {
      return sessionStorage.getItem(CONFIG.storageKey) === "1";
    } catch (e) {
      return false;
    }
  }

  // Se il link contiene il parametro giusto, salva l'eleggibilità per tutta la sessione
  if (isEligibleFromUrl()) {
    markEligible();
  }

  let isProcessing = false;
  let needsRerun = false;

  // Modalità diagnostica (spenta di default, invisibile ai clienti).
  // Si attiva aprendo il sito con &giftdebug=1 nell'URL e resta attiva
  // per la sessione. Stampa in Console i tempi di ogni passaggio.
  const startedAt = performance.now();
  let debugOn = false;
  try {
    if (new URLSearchParams(window.location.search).get("giftdebug") === "1") {
      sessionStorage.setItem("gift_debug", "1");
    }
    debugOn = sessionStorage.getItem("gift_debug") === "1";
  } catch (e) {
    /* ignora */
  }
  function log(...parts) {
    if (!debugOn) return;
    console.log(
      "[gift-email-promo +" + Math.round(performance.now() - startedAt) + "ms]",
      ...parts,
    );
  }

  function getGiftLineItem(cart) {
    // Il gift si riconosce dalla variante (il prodotto a $0 è usato solo per
    // questa promo) oppure dalla property, per i carrelli aggiunti con la
    // versione precedente dello script.
    return cart.items.find(
      (item) =>
        item.variant_id === CONFIG.giftVariantId ||
        (item.properties && item.properties[CONFIG.giftPropertyKey] === "true")
    );
  }

  // Le richieste fatte da questo script portano il marcatore __gift, che il
  // fetch-watcher usa per non rivalutare il carrello a causa di sé stesso
  // (evita un giro di rete inutile dopo ogni aggiunta/rimozione del gift).
  // Aggiunta con /cart/update.js invece di /cart/add.js: per Shopify aggiunge
  // la riga se la variante non è ancora nel carrello. Alcune app (es. popup
  // di upsell) intercettano le chiamate a /cart/add e le tengono ferme finché
  // il cliente non risponde al popup: usare update.js evita quel blocco.
  // Se per qualche motivo il gift non risulta nel carrello dopo update.js,
  // si ripiega su /cart/add.js (più lento in presenza del popup, ma sicuro).
  function addGiftViaAdd() {
    log("ripiego su /cart/add per aggiungere il gift");
    return fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      __gift: true,
      body: JSON.stringify({
        items: [
          {
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: {
              [CONFIG.giftPropertyKey]: "true",
            },
          },
        ],
      }),
    });
  }

  function addGift() {
    log("aggiungo il gift (richiesta /cart/update)");
    // Usiamo l'endpoint .js, che risponde sempre in JSON
    const updateUrl = window.routes.cart_update_url.replace(/\.js$/, "") + ".js";
    return fetch(updateUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      __gift: true,
      body: JSON.stringify({
        updates: { [CONFIG.giftVariantId]: 1 },
      }),
    })
      .then((res) => res.json())
      .then((cart) => {
        const added =
          cart &&
          Array.isArray(cart.items) &&
          cart.items.some((item) => item.variant_id === CONFIG.giftVariantId);
        log("risposta ricevuta, gift nel carrello:", !!added);
        if (!added) return addGiftViaAdd();
      })
      .catch((e) => {
        console.error("[gift-email-promo] update.js fallito, ripiego su add:", e);
        return addGiftViaAdd();
      });
  }

  function removeGift(lineKey) {
    log("rimuovo il gift");
    return fetch(window.routes.cart_change_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      __gift: true,
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
      }),
    });
  }

  function refreshCartUi() {
    // Riusa lo stesso evento del tema per far ricaricare drawer/pagina carrello.
    // "source" diverso da "cart-items" così il refresh nativo del tema viene
    // eseguito regolarmente. Un filo più lento, ma affidabile.
    log("chiedo al tema di ridisegnare il carrello");
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "gift-email-promo" });
    }
  }

  function setGiftQuantity(lineKey, quantity) {
    log("riporto il gift a quantità", quantity);
    return fetch(window.routes.cart_change_url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      __gift: true,
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
      }),
    });
  }

  function evaluateCart() {
    if (!CONFIG.giftVariantId) {
      console.warn("[gift-email-promo] giftVariantId non configurato.");
      return;
    }

    // Se il visitatore non è idoneo (non è mai arrivato dal link email in questa
    // sessione), non ha senso interrogare il carrello: evitiamo del tutto la
    // chiamata di rete per la stragrande maggioranza dei visitatori del sito.
    if (!isEligible()) return;

    // Blocco anti-concorrenza: se una valutazione è già in corso, ne
    // memorizziamo la richiesta e la rifacciamo una sola volta alla fine.
    // Il blocco scatta PRIMA di leggere il carrello, così due eventi quasi
    // simultanei (tema + watcher di rete) non possono aggiungere il gift due volte.
    if (isProcessing) {
      log("valutazione già in corso, ne rifaccio una alla fine");
      needsRerun = true;
      return;
    }
    isProcessing = true;
    needsRerun = false;
    log("valuto il carrello (leggo /cart.js)");

    fetch(window.routes.cart_url + ".js")
      .then((res) => res.json())
      .then((cart) => {
        const totalInCurrency = cart.total_price / 100;
        const giftItem = getGiftLineItem(cart);
        const meetsThreshold = totalInCurrency >= CONFIG.thresholdAmount;
        log(
          "totale carrello:",
          totalInCurrency,
          "| soglia raggiunta:",
          meetsThreshold,
          "| gift presente:",
          !!giftItem,
        );

        if (meetsThreshold && !giftItem) {
          return addGift().then(() => refreshCartUi());
        }
        if (giftItem && !meetsThreshold) {
          return removeGift(giftItem.key).then(() => refreshCartUi());
        }
        // Il regalo deve essere sempre in quantità 1, anche se qualcosa
        // (o il cliente stesso) l'ha portato a più pezzi.
        if (giftItem && meetsThreshold && giftItem.quantity !== 1) {
          return setGiftQuantity(giftItem.key, 1).then(() => refreshCartUi());
        }
      })
      .catch((e) => console.error("[gift-email-promo] errore:", e))
      .finally(() => {
        isProcessing = false;
        if (needsRerun) {
          needsRerun = false;
          evaluateCart();
        }
      });
  }

  function installCartFetchWatcher() {
    if (window.__giftEmailPromoFetchPatched) return;
    window.__giftEmailPromoFetchPatched = true;

    const originalFetch = window.fetch;
    const watchedUrls = [
      window.routes.cart_add_url,
      window.routes.cart_change_url,
      window.routes.cart_update_url,
    ].filter(Boolean);

    window.fetch = function (...args) {
      const requestUrl =
        typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      const isOwnRequest = !!(args[1] && args[1].__gift);
      const isCartMutation =
        !isOwnRequest && watchedUrls.some((url) => requestUrl.includes(url));

      const fetchPromise = originalFetch.apply(this, args);

      if (isCartMutation) {
        log("rilevata modifica del carrello da altri:", requestUrl);
        fetchPromise
          .then((response) => {
            // Reagiamo appena la chiamata reale è completata, senza
            // aspettare che eventuali popup di altre app (es. upsell)
            // finiscano la loro interazione.
            evaluateCart();
            return response;
          })
          .catch(() => {
            /* eventuali errori li gestisce già chi ha fatto la chiamata originale */
          });
      }

      return fetchPromise;
    };
  }
  function init() {
    // Intercetta le chiamate di rete reali verso il carrello: reagiamo
    // subito, senza dipendere dai tempi di eventuali popup di altre app
    // (es. upsell) che potrebbero ritardare l'evento del tema.
    installCartFetchWatcher();

    // Controlla subito al caricamento pagina (utile se il cliente arriva
    // già con articoli nel carrello da una sessione precedente)
    evaluateCart();

    // Manteniamo anche l'aggancio agli eventi del tema come rete di
    // sicurezza aggiuntiva (isProcessing evita azioni duplicate se
    // scattano entrambi i meccanismi quasi insieme)
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Evita loop: ignora gli eventi generati da questo stesso script
        if (event && event.source === "gift-email-promo") return;
        log("evento cart-update dal tema, sorgente:", event && event.source);
        evaluateCart();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();